export const environment = {
	production: true,
	name: 'hairlines'
};